import * as swcHelpers from '@swc/helpers';
import { fromStoreQueryToStore } from '../adapters/from-store-query-to-store.js';
import { GET_BOOK_APPOINTMENT_STORE } from '../queries/get-book-appointment-store.js';

const getBookAppointmentStore = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, code, locale, isTryInStoreFlowEnabled) {
        if (code === undefined) {
            return null;
        }
        try {
            const { data , error  } = yield apolloClient.query(swcHelpers.objectSpread({
                query: GET_BOOK_APPOINTMENT_STORE,
                variables: {
                    code
                }
            }, locale ? {
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            } : {}));
            const storeQueryData = data === null || data === void 0 ? void 0 : data.store;
            const storeData = fromStoreQueryToStore(storeQueryData, [
                {
                    tryInStore: isTryInStoreFlowEnabled
                }, 
            ]);
            if (error) {
                console.error(error);
            }
            return storeData;
        } catch (error) {
            console.error(error);
            return null;
        }
    });
    return function getBookAppointmentStore(apolloClient, code, locale, isTryInStoreFlowEnabled) {
        return _ref.apply(this, arguments);
    };
}();

export { getBookAppointmentStore };
//# sourceMappingURL=book-appointment-store.js.map
